module.exports = __webpack_public_path__ + "static/media/description-signals.3bfd4c5f.svg";